export default __webpack_public_path__ + "static/media/newslit-logo.125a5059.svg";